import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Checkbox } from './ui/checkbox';
import { Label } from './ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

// Static color classes for Tailwind purge safety
const CONVERSION_BADGE = 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300';
const PARTIAL_BADGE    = 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300';

export { CONVERSION_BADGE, PARTIAL_BADGE };

export function BusinessSelectionModal({ open, onOpenChange, businessTypes = [], onConfirm }) {
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (open) setSelected([...businessTypes]);
  }, [open, businessTypes.join(',')]); // eslint-disable-line react-hooks/exhaustive-deps

  const toggle = (bt) => {
    setSelected(prev =>
      prev.includes(bt) ? prev.filter(x => x !== bt) : [...prev, bt]
    );
  };

  const handleConfirm = () => {
    const remaining = businessTypes.filter(bt => !selected.includes(bt));
    onConfirm(selected, remaining);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>¿Qué negocios se cerraron?</DialogTitle>
          <DialogDescription>
            Selecciona los negocios/planes que se convirtieron a cliente.
            Los no seleccionados permanecerán en negociación.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-2">
          {businessTypes.map(bt => (
            <div key={bt} className="flex items-center gap-3">
              <Checkbox
                id={`bt-${bt}`}
                checked={selected.includes(bt)}
                onCheckedChange={() => toggle(bt)}
              />
              <Label htmlFor={`bt-${bt}`} className="cursor-pointer">{bt}</Label>
            </div>
          ))}
        </div>
        <div className="flex justify-end gap-2 pt-2 border-t">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button
            onClick={handleConfirm}
            disabled={selected.length === 0}
            className="bg-[#1a365d] hover:bg-[#1a365d]/90 text-white"
          >
            Confirmar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default BusinessSelectionModal;
